import React from 'react';
import { Logo } from './Logo';
import { 
    SparklesIcon, 
    HeartIcon, 
    MoonIcon, 
    ChevronRightIcon,
    CardsIcon
} from './Icons';

interface ResourcesPageProps {
    onNavigate: (page: string) => void;
}

export const ResourcesPage: React.FC<ResourcesPageProps> = ({ onNavigate }) => {
    const tools = [
        {
            id: 'tarot',
            title: 'Tirage de Tarot',
            subtitle: 'Tirage interactif 3 cartes, Amour, Avenir & Guidance',
            icon: <CardsIcon className="w-6 h-6 text-amber-300" />,
            gradient: 'from-amber-950/70 to-purple-950/70 border-amber-500/40 text-amber-300'
        },
        {
            id: 'love',
            title: 'Love Match',
            subtitle: 'Calculez votre compatibilité amoureuse & affinités célestes',
            icon: <HeartIcon className="w-6 h-6 text-pink-300 fill-pink-400/20" />,
            gradient: 'from-pink-950/70 to-rose-950/70 border-pink-500/40 text-pink-300'
        },
        {
            id: 'dreams',
            title: 'Explication des Rêves',
            subtitle: 'Découvrez la signification cachée de vos visions nocturnes',
            icon: <MoonIcon className="w-6 h-6 text-indigo-300" />,
            gradient: 'from-indigo-950/70 to-blue-950/70 border-indigo-500/40 text-indigo-300'
        },
        {
            id: 'numerology',
            title: 'Numérologie',
            subtitle: 'Révélez votre chemin de vie et vos cycles karmiques',
            icon: <SparklesIcon className="w-6 h-6 text-cyan-300" />,
            gradient: 'from-cyan-950/70 to-indigo-950/70 border-cyan-500/40 text-cyan-300'
        },
        {
            id: 'crystal',
            title: 'Boule de Cristal',
            subtitle: 'Flash médiumnique et réponses instantanées par les astres',
            icon: <SparklesIcon className="w-6 h-6 text-fuchsia-300" />,
            gradient: 'from-fuchsia-950/70 to-purple-950/70 border-fuchsia-500/40 text-fuchsia-300'
        },
        {
            id: 'horoscope',
            title: 'Horoscope du Jour',
            subtitle: 'Climat astral, énergies amoureuses et conseils pour les 12 signes',
            icon: <CardsIcon className="w-6 h-6 text-purple-300" />,
            gradient: 'from-purple-950/70 to-violet-950/70 border-purple-500/40 text-purple-300'
        }
    ];

    return (
        <div className="min-h-screen bg-[#08081A] text-white pt-6 pb-28 px-4 max-w-4xl mx-auto animate-fade-in">
            {/* Header */}
            <div className="text-center mb-8 pb-4 border-b border-purple-900/40">
                <Logo size="md" showTagline={true} onClick={() => onNavigate('home')} />
                <h1 className="text-xl sm:text-2xl font-serif font-bold text-white mt-3">
                    Nos Outils & Ressources de Divination
                </h1>
                <p className="text-xs text-purple-300/80 mt-1 max-w-md mx-auto">
                    Explorez gratuitement les arts divinatoires pour éclairer vos décisions sentimentales et spirituelles.
                </p>
            </div>

            {/* Grille des Outils */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {tools.map((tool) => (
                    <button
                        key={tool.id}
                        onClick={() => onNavigate(tool.id)}
                        className={`text-left p-5 rounded-3xl bg-gradient-to-br ${tool.gradient} border backdrop-blur-md hover:border-gold-400/80 shadow-xl transition-all duration-300 hover:scale-[1.03] active:scale-98 flex flex-col justify-between h-44 group cursor-pointer`}
                    >
                        <div className="flex items-start justify-between">
                            <span className="text-3xl p-2.5 rounded-2xl bg-black/40 border border-white/10 group-hover:scale-110 transition-transform shadow-md">
                                {tool.icon}
                            </span>
                            <span className="text-xs font-bold bg-white/10 group-hover:bg-amber-400 group-hover:text-black px-2.5 py-1 rounded-full text-purple-200 transition-colors">
                                Découvrir →
                            </span>
                        </div>

                        <div>
                            <h3 className="text-base font-serif font-bold text-white group-hover:text-amber-200 transition-colors">
                                {tool.title}
                            </h3>
                            <p className="text-xs text-purple-200/70 line-clamp-2 mt-1 leading-snug">
                                {tool.subtitle}
                            </p>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default ResourcesPage;
